/* eslint-disable import/order */
import React from 'react';
import { useLocation } from '@jira/navigation-apps__routing-hooks/src/useLocation.tsx';
import { issueCreateRedirectRoute } from '@jira/router-routes__issue-create-redirect-routes/src/issueCreateRedirectRoute.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import type { Route } from '@atlassian/react-resource-router';

const RedirectComponent = () => {
	const { pathname, search } = useLocation();
	const redirectUrl = `${pathname.replace('/jira/', '/')}${search}`;

	return (
		<>
			<meta http-equiv="Refresh" content={`0;url=${redirectUrl}`} />
		</>
	);
};

export const issueCreateRedirectRouteEntry: Route = createEntry(issueCreateRedirectRoute, () => ({
	// eslint-disable-next-line no-restricted-syntax
	component: RedirectComponent,
	layout: globalLayout,
	resources: [...jiraSpaResources()],
	isRedirect: true,
	canTransitionIn: () => false,
	forPaint: [LazyAtlassianNavigation],
	bifrost: {
		bifrostGroup: 'shell-only',
		redirects: [
			{
				key: 'issue-create-redirect',
				timeoutMs: 100,
				handler: async ({ url }) => {
					const newPath = url.pathname.replace('/jira/', '/');
					return newPath + (url.search ?? '');
				},
			},
		],
	},
}));
